// CANONICAL COPY (GH #7115). src/constants/obligations/obl-isms-metrics.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-isms-metrics',
  title: 'Review ISMS performance measurement',
  description:
    'Determine what ISMS performance indicators shall be monitored and measured, including methods and frequency. Review measurement results and retain documented evidence to support management review.',
  category: 'governance',
  scfIds: ['SCF-MSS-005'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'ISMS performance measurement plan or report is published',
    },
    { type: 'document-within-sla', description: 'Measurement review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
